import React, { useState } from 'react'
import PageBody from 'Common/Custom/PageBody'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import SlotListTable from './Components/SlotListTable'
import { useRoleVerify } from 'Common/RoleVerify'
import AddSlot from '../AddSlot/AddSlot'

const SlotList = () => {
    const [refetch, setRefetch] = useState(false)
    const canShowAction = useRoleVerify("", ["can_create"]);
    return (
        <>
            {canShowAction &&
                <AddSlot
                    setRefetch={setRefetch}
                    refetch={refetch}
                />}

            <PageBody
                card={true}
                headerchildren={
                    <>
                        <HeadingOne>Slot List</HeadingOne>
                    </>
                }>

                {/* Table section */}
                <div className="col-12">
                    <SlotListTable refetch={refetch} />
                </div>
            </PageBody>
        </>
    )
}

export default SlotList
